import { HydraulicType } from '@/types/hydraulic'

export const initialState: InterfaceCommonDataState = {
  hydraulicData: {},
}

export interface InterfaceCommonDataState {
  hydraulicData: Record<string, HydraulicType[]>
}
